import type { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';

import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationMenuService } from '@commons/navigation-menu/navigation-menu.service';
import { isLogged, jwtDelete, roles } from '@loyalty/utils-angular/stores';
import { Store as NgrxStore } from '@ngrx/store';
import { of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';

export const defaultRouteGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(NgrxStore);
  const layoutMenuService = inject(NavigationMenuService);
  const router = inject(Router);

  const isFirstItemQuery = state.url.substring(0, state.url.indexOf('?')) === '/';
  if (!isFirstItemQuery && state.url !== '/') {
    return of(true);
  }
  return store.select(isLogged).pipe(
    filter((isLogged) => isLogged),
    switchMap(() => store.select(roles)),
    filter((roles): roles is string[] => !!roles),
    map((roles) => {
      const grantedRoute = layoutMenuService.getFirstGrantedItemRoute(roles);
      if (!grantedRoute) {
        store.dispatch(jwtDelete());
      }
      return router.createUrlTree([grantedRoute]);
    })
  );
};
